export const LOGIN = "/v2/login";
export const TEMP_LOGIN = "/v2/establishment/login";
export const MINISTRY_LOGIN = "/v2/ministry/login";
export const LOGOUT = "/v2/logout";
export const MINISTRY_LOGOUT = "/v2/ministry/logout";
export const SLIDERS = "/v2/login-sliders";
export const CHANGE_PASSWORD = (id) => `v2/change-password-user/${id}`;
export const TEMP_LOGOUT = "/v2/establishment/logout";
